import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
// This Module's Components
import { AlertAdvisoriesComponent } from './alert-advisories.component';
import { TranslatedsitesLangService } from '../../services/translatedsites/translatedsiteslang.service';

@NgModule({
  imports: [CommonModule, DataLayerModule, ModalModule.forRoot()],
  declarations: [AlertAdvisoriesComponent],
  exports: [AlertAdvisoriesComponent],
  providers: [TranslatedsitesLangService]
})
export class AlertAdvisoriesModule {}
